// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M17.0179 2.04804L16.0526 1.78687L15.5302 3.71745L16.4955 3.97862C17.3393 4.20693 18.1085 4.65246 18.7264 5.27078C19.3443 5.8891 19.7893 6.6586 20.017 7.50255L20.2775 8.46803L22.2084 7.94702L21.9479 6.98155C21.6291 5.80002 21.0061 4.72271 20.1411 3.85706C19.276 2.99141 18.1992 2.36767 17.0179 2.04804Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16.1039 5.42618L15.1386 5.16501L14.6162 7.09559L15.5815 7.35676C15.8346 7.42526 16.0654 7.55891 16.2508 7.74441C16.4361 7.92991 16.5696 8.16076 16.6379 8.41394L16.8984 9.37942L18.8294 8.85841L18.5689 7.89293C18.4095 7.30217 18.098 6.76352 17.6655 6.33069C17.233 5.89787 16.6945 5.586 16.1039 5.42618Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.57995 2H1V3C1 6.99781 2.17402 10.7245 4.19641 13.8503C5.73668 16.2311 7.76894 18.2633 10.1497 19.8036C13.2755 21.826 17.0022 23 21 23H22V14.4201L15.3094 12.9332L13.4504 14.7922C11.7492 13.7006 10.2994 12.2508 9.2078 10.5496L11.0668 8.69061L9.57995 2Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-call-1-filled')
export default class Call1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'call-1-filled',
    }
  }
}
